import manualsEndpoint from 'app/api/services/manualsEndpoint';
import { errorHandler } from 'app/utils/errorHandler';

const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
  files: [],
};

const manualsSlice = createSlice({
  name: 'manuals',
  initialState,
  reducers: {
    getManuals(state, action) {
      state.files = action.payload;
    },
    clearManuals(state, action) {
      state.files = initialState.files;
    },
  },
});


export const fetchAllManuals = () => async dispatch => {
    try {
        const response = await manualsEndpoint.getAll();
        if(response.status === 200 && response.data){
            dispatch(getManuals(response.data));
        }
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
}

export const {
    getManuals,
    clearManuals
} = manualsSlice.actions;

export default manualsSlice;